<template>
  <div>
    <BaseHeadline icon="mdi-home-city" :headerName="title">
      <template v-slot:headlineBtns>
        <v-btn-toggle class="mr-3 mb-0" mandatory color="primary" dense>
          <v-btn :to="{ name: 'Projects' }" exact depressed>
            {{ isTrysilhus ? "Mine favoritter" : "Vis mine" }}
          </v-btn>

          <v-btn
            :to="{ name: 'Projects', query: { show: 'all' } }"
            exact
            depressed
            value="all"
          >
            Vis alle
          </v-btn>
        </v-btn-toggle>

        <v-btn
          v-if="isFilterOn"
          outlined
          class="mr-3 mb-0"
          color="primary"
          depressed
          @click="removeFilter"
        >
          Slett filter
        </v-btn>
        <v-badge
          class="mr-3 mb-0 badgeFlex"
          :content="filterCount"
          :value="filterCount"
          color="secondary"
          bordered
          overlap
        >
          <v-btn color="primary" depressed @click="openfilter"> Filter </v-btn>
        </v-badge>
      </template>
    </BaseHeadline>

    <Searchbar class="mt-4 mb-4" v-model="search" />

    <v-btn-toggle
      v-if="$vuetify.breakpoint.mobile"
      style="width: 50%"
      class="mb-4"
      mandatory
      color="primary"
      dense
    >
      <v-btn :to="{ name: 'Projects' }" block exact depressed>
        {{ isTrysilhus ? "Mine favoritter" : "Vis mine" }}
      </v-btn>

      <v-btn
        :to="{ name: 'Projects', query: { show: 'all' } }"
        exact
        block
        depressed
        value="all"
      >
        Vis alle
      </v-btn>
    </v-btn-toggle>

    <FilterBar
      class="mb-4"
      v-if="$vuetify.breakpoint.mobile"
      :buttons="buttons"
      @filter="openfilter"
      @removeFilter="removeFilter"
    />

    <ProjCards
      v-model="getProjects"
      :loading="loadingProjects"
      @click="clickProject"
    />
    <ProjectsFilterDialog
      v-model="showFilterDialog"
      :selectedStatus.sync="selectedStatus"
      :projectStatuses="projectStatuses"
      :selectedProjType.sync="selectedProjType"
      :projTypes="projTypes"
      @deleteStatus="remmoveStatus"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import notification from "@/helpers/notification";
import projectApi from "@/api/projectApi";
import contactpersonApi from "@/api/contactpersonApi";

import BaseHeadline from "@/components/shared/BaseHeadline.vue";
import Searchbar from "@/components/shared/search/Searchbar.vue";
import ProjCards from "@/components/projects/children/ProjCards.vue";
import ProjectsFilterDialog from "@/components/projects/children/ProjectsFilterDialog.vue";
import FilterBar from "@/components/shared/FilterBar.vue";

import { ProjectObject, FilterBtnObject } from "@/types/interface";

export default Vue.extend({
  data: () => ({
    filter: "all",
    projects: new Array<ProjectObject>(),
    loadingProjects: false,
    search: "",
    showFilterDialog: false,
    selectedProjType: "",
    projTypes: [],
    selectedStatus: new Array<string>(),
    defaultSelectedStatus: [
      "Vurdering",
      "Forprosjekt",
      "Detaljprosjekt",
      "Gjennomføring",
      "Etterbruk",
    ] as Array<any>,
    projectStatuses: [] as Array<any>,
  }),

  mounted() {
    this.fetchData(true);
    this.$watch(
      () => this.$route,
      () => {
        // react to route changes...
        this.fetchData();
      }
    );
    this.InitializeFilter();
  },
  // beforeDestroy() {
  //   this.setHeaderName("");
  // },
  methods: {
    // ...mapActions({
    //   setHeaderName: "shared/setHeaderName",
    // }),
    async fetchData(isMounted = false) {
      this.loadingProjects = true;
      this.projects = [];
      let psiAgreementKey = [];
      await contactpersonApi.getUserSetting("psiAgreement").then((response) => {
        psiAgreementKey = response;
      });

      if (this.$route.query.show === "all") {
        await projectApi
          .getProjects()
          .then((Response) => {
            // debugger;
            this.projects = Response.projects;
            this.projects.forEach((x) => {
              var psiAgreement = psiAgreementKey[x.id] as any;
              if (psiAgreement && psiAgreement.confirm) {
                x.psiConfirmed = psiAgreement.confirm;
              }
            });
            this.loadingProjects = false;
          })
          .catch(() => {
            this.loadingProjects = false;
          });
      } else {
        await projectApi
          .getFavoritesProjects()
          .then((Response) => {
            if (Response.projects.length < 1 && isMounted) {
              this.$router.push({ name: "Projects", query: { show: "all" } });
            } else {
              this.projects = Response.projects;
              this.projects.forEach((x) => {
                var psiAgreement = psiAgreementKey[x.id] as any;
                if (psiAgreement && psiAgreement.confirm) {
                  x.psiConfirmed = psiAgreement.confirm;
                }
              });

              this.loadingProjects = false;
            }
          })
          .catch(() => {
            this.loadingProjects = false;
          });
      }
    },
    // setTitle() {
    //   var title = "";
    //   if (this.isTrysilhus) {
    //     title =
    //       this.$route.query.show === "all"
    //         ? "Alle prosjekter"
    //         : "Favorittprosjekter";
    //   } else {
    //     title =
    //       this.$route.query.show === "all"
    //         ? "Alle prosjekter til firma"
    //         : "Dine prosjekter";
    //   }
    //   // this.setHeaderName(title);
    // },
    clickShow() {
      this.$router.push({ name: "Projects", query: { show: "all" } });
    },
    clickProject(project: ProjectObject) {
      this.$router.push({
        name: "Project",
        params: { id: project.id.toString() },
      });
    },
    async openfilter() {
      if (this.projTypes.length > 0 && this.projectStatuses.length > 0) {
        this.showFilterDialog = true;
      } else {
        await projectApi
          .getProjectsFilterOptions()
          .then((r) => {
            this.projTypes = r.projTypes;
            this.projectStatuses = r.projectStatuses;
            this.showFilterDialog = true;
          })
          .catch(() => {
            notification.error("Kunne ikke hente filter!");
          });
      }
    },
    removeFilter() {
      this.search = "";
      this.selectedProjType = "";
      this.projTypes = [];
      this.selectedStatus = [...this.defaultSelectedStatus];
      this.projectStatuses = [];
    },
    InitializeFilter() {
      // this.selectedStatus.push(
      //   "Vurdering",
      //   "Forprosjekt",
      //   "Detaljprosjekt",
      //   "Gjennomføring",
      //   "Etterbruk"
      // );
      this.selectedStatus = [...this.defaultSelectedStatus];
    },
    remmoveStatus(value) {
      let indexToRemove = this.selectedStatus.indexOf(value);
      if (indexToRemove > -1) {
        this.selectedStatus.splice(indexToRemove, 1);
      }
    },
  },

  computed: {
    ...mapGetters({
      isTrysilhus: "shared/isTrysilhus",
      isMainContactPerson: "shared/isMainContactPerson",
      profile: "shared/profile",
    }),

    getProjects(): Array<ProjectObject> {
      if (
        this.search ||
        this.selectedStatus.length > 0 ||
        this.selectedProjType
      ) {
        return this.projects?.filter((x) => {
          return (
            (this.search
              ? x.name.toUpperCase().includes(this.search.toUpperCase())
              : true) &&
            (this.selectedStatus?.length > 0
              ? this.selectedStatus.indexOf(x.projStatusString) >= 0
              : true) &&
            (this.selectedProjType
              ? x.projTypeName === this.selectedProjType
              : true)
          );
        });
      }
      return this.projects;
    },
    filterCount() {
      let count = 0;
      if (this.search) count = count + 1;
      if (this.selectedProjType) count = count + 1;
      if (this.selectedStatus.length > 0) count = count + 1;

      return count;
    },
    isFilterOn(): boolean {
      if (
        this.search ||
        this.selectedProjType ||
        !(
          this.selectedStatus.length === this.defaultSelectedStatus.length &&
          this.selectedStatus.every(
            (value, index) => value === this.defaultSelectedStatus[index]
          )
        )
      ) {
        return true;
      }
      return false;
    },
    buttons(): Array<FilterBtnObject> {
      var buttons = [
        {
          show: this.isFilterOn ? true : false,
          name: "Slett filter",
          color: "lightGrey",
          emit: "removeFilter",
        },
        {
          show: true,
          name: "Filter",
          color: "primary",
          emit: "filter",
          badge: this.filterCount,
          badgeColor: "yellow",
        },
      ] as Array<FilterBtnObject>;

      return buttons;
    },
    title(): string {
      if (this.isTrysilhus) {
        return this.$route.query.show === "all"
          ? "Alle prosjekter"
          : "Favorittprosjekter";
      } else {
        return this.$route.query.show === "all"
          ? "Alle prosjekter til firma"
          : "Mine prosjekter";
      }
    },
  },
  components: {
    BaseHeadline,
    Searchbar,
    ProjCards,
    ProjectsFilterDialog,
    FilterBar,
  },
});
</script>
